<template>
  <header class="header-top">
    <div class="hambuerger" v-on:click="toggleBar" @mouseenter="hover()">
      <font-awesome-icon icon="bars" />
    </div>
    <div class="header-buttons">
      <SearchButtonVue v-if="$route.path != '/accountsettings'"/>
      <NotificationButtonVue />
      <ProfileItemVue />
    </div>
    <div class="menu-hover" v-if="ishover" @mouseleave="ishover = false">
      <ul>
        <li>
          <router-link to="/"
            ><p>Projects</p>
            <font-awesome-icon icon="chevron-right"
          /></router-link>
        </li>
        <li>
          <router-link to="/project/Design and operation for hydraulic fracturing, Well PE32 – Technical support"
            ><p>Dashboard</p>
            <font-awesome-icon icon="chevron-right"
          /></router-link>
        </li>
        <li>
          <router-link to="/calendar"
            ><p>Calendar</p>
            <font-awesome-icon icon="chevron-right"
          /></router-link>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
import NotificationButtonVue from "./NotificationButton.vue";
import ProfileItemVue from "./ProfileItem.vue";
import SearchButtonVue from "./SearchButton.vue";
import { mapMutations, mapGetters } from "vuex";
export default {
  components: {
    NotificationButtonVue,
    SearchButtonVue,
    ProfileItemVue,
  },
  data: () => ({
    ishover: false,
  }),
  computed: {
    ...mapGetters(["getOpenBar"]),
  },
  watch: {
    getOpenBar(newValue) {
      if (newValue) {
        this.ishover = false;
      }
    },
  },
  methods: {
    ...mapMutations(["toggleBar"]),
    hover() {
      if (!this.getOpenBar) {
        this.ishover = !this.ishover;
      }
    },
  },
};
</script>

<style scoped>
.header-top {
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 50px;
  background: var(--firts-color);
}
.header-top .menu-hover {
  position: absolute;
  width: auto;
  height: auto;
  background: white;
  top: 50px;
  color: black;
  transition: 0.5s;
}
.header-top .menu-hover.active {
  position: absolute;
  width: auto;
  height: auto;
  background: white;
  top: 50px;
  color: black;
}
.header-top .menu-hover ul {
  list-style-type: none;
  padding: 0;
}
.header-top .menu-hover ul li {
  padding: 5px 10px 5px 5px;
  border-bottom: 1px solid var(--third-color);
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.header-top .menu-hover ul li a {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-top .menu-hover ul li a p {
  margin-bottom: 0;
  margin-right: 5px;
}
.header-top .hambuerger {
  color: #fff;
  font-size: 2rem;
  padding: 0 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.header-top .hambuerger:hover {
  border-radius: 100%;
  opacity: 0.8;
}
.header-top .header-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Poppins, Bold;
  font-size: 4.375rem;
  margin-bottom: 20px;
  color: #ecc030;
}
.header-top .header-logo p {
  margin: 0;
}
.header-top .header-buttons {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>